import { DELIVERY_TYPES, getOrderDeliveryType } from 'src/constants/deliveryTypes';
import { ORDER_STATUS } from 'src/constants/order';
import { TOrder } from 'src/types/orders';
import { getNextStatus, statusManagementAvailable } from '~/view/components/AggregatorManager/helpers/AggregatorManagerHelpers';
import { AGGREGATOR_ORDER_SCHEME } from '~/constants/aggregators';

export enum POS_NAME {
  // TODO: add other pos name
  KUDU = 'kudu',
}

const orderStatusManager = (order: TOrder | null) => {
  if (!order) return null;

  const { foodics_id: posId, delivery_type_code: deliveryCode, order_status_code: statusCode, pos_system_name: posName } = order;
  const pickup: boolean = getOrderDeliveryType(deliveryCode) === DELIVERY_TYPES.PICKUP;

  // aggregator
  if (order.aggregator_key && AGGREGATOR_ORDER_SCHEME[order.aggregator_key].statusSwitchButtonSteps) {
    if (!statusManagementAvailable(order)) {
      return null;
    }

    return {
      nextStatusCode: getNextStatus(order) || ORDER_STATUS.PENDING,
      messageText: posId ? 'confirm_change_status_foodics' : 'confirm_change_status',
      cancellingOrder: true,
      cancellingMessageText: posId ? 'confirm_canceling_order_foodics' : 'confirm_change_status',
      completedButton: false,
    };
  }

  // kudu
  if (posId && posName?.toLowerCase() === POS_NAME.KUDU) {
    return pickup ? PickupKudu(statusCode) : DeliveryKudu(statusCode);
  }
  // foodics and other pos
  if (posId) {
    return pickup ? PickupFoodics(statusCode) : DeliveryFoodics(statusCode);
  }

  // without pos
  return pickup ? Pickup(statusCode) : Delivery(statusCode);
};

/*
 *
 *
 * foodics
 *
 *
 */
const PickupFoodics = (statusCode: TOrder['order_status_code']) => {
  let nextStatusCode: TOrder['order_status_code'] = ORDER_STATUS.PENDING;
  let messageText: string = 'confirm_change_status_foodics';
  let cancellingOrder: boolean = true;
  let cancellingMessageText: string = 'confirm_canceling_order_foodics';
  let completedButton: boolean = false;

  switch (true) {
    case statusCode === ORDER_STATUS.PENDING:
      nextStatusCode = ORDER_STATUS.ACCEPTED;
      messageText = 'sure_confirm_change_status_foodics';
      cancellingOrder = true;
      cancellingMessageText = 'confirm_canceling_pending_order_foodics';
      break;
    case statusCode === ORDER_STATUS.PROCESSING:
    case statusCode === ORDER_STATUS.ASSIGNED:
    case statusCode === ORDER_STATUS.ACCEPTED:
      nextStatusCode = ORDER_STATUS.WAITING_FOR_PICKUP;
      break;
    case statusCode === ORDER_STATUS.PICKEDUP:
    case statusCode === ORDER_STATUS.OUT_FOR_DELIVERY:
    case statusCode === ORDER_STATUS.WAITING_FOR_PICKUP:
      nextStatusCode = ORDER_STATUS.RETURNED;
      completedButton = true;
      break;
    case statusCode === ORDER_STATUS.RETURNED:
      nextStatusCode = ORDER_STATUS.COMPLETED;
      break;
  }
  return { messageText, cancellingMessageText, nextStatusCode, completedButton, cancellingOrder };
};
const DeliveryFoodics = (statusCode: TOrder['order_status_code']) => {
  let nextStatusCode: TOrder['order_status_code'] = ORDER_STATUS.PENDING;
  let messageText: string = 'confirm_change_status_foodics';
  let cancellingOrder: boolean = true;
  let cancellingMessageText: string = 'confirm_canceling_order_foodics';
  let completedButton: boolean = false;

  switch (true) {
    case statusCode === ORDER_STATUS.PENDING:
      nextStatusCode = ORDER_STATUS.ACCEPTED;
      messageText = 'sure_confirm_change_status_foodics';
      cancellingOrder = true;
      cancellingMessageText = 'canceling_foodics_delivery_pending';
      break;
    case statusCode === ORDER_STATUS.PROCESSING:
    case statusCode === ORDER_STATUS.ASSIGNED:
    case statusCode === ORDER_STATUS.ACCEPTED:
      nextStatusCode = ORDER_STATUS.WAITING_FOR_PICKUP;
      break;
    case statusCode === ORDER_STATUS.PICKEDUP:
    case statusCode === ORDER_STATUS.WAITING_FOR_PICKUP:
      nextStatusCode = ORDER_STATUS.OUT_FOR_DELIVERY;
      break;
    case statusCode === ORDER_STATUS.OUT_FOR_DELIVERY:
      nextStatusCode = ORDER_STATUS.RETURNED;
      completedButton = true;
      break;
    case statusCode === ORDER_STATUS.RETURNED:
      nextStatusCode = ORDER_STATUS.COMPLETED;
      break;
  }
  return { messageText, cancellingMessageText, nextStatusCode, completedButton, cancellingOrder };
};

/*
 *
 *
 * kudu
 *
 *
 */
const PickupKudu = (statusCode: TOrder['order_status_code']) => {
  let nextStatusCode: TOrder['order_status_code'] = ORDER_STATUS.PENDING;
  let messageText: string = 'confirm_change_status_foodics';
  let cancellingOrder: boolean = true;
  let cancellingMessageText: string = 'confirm_canceling_order_foodics';
  let completedButton: boolean = false;

  switch (true) {
    case statusCode === ORDER_STATUS.PENDING:
      nextStatusCode = ORDER_STATUS.ACCEPTED;
      messageText = 'sure_confirm_change_status';
      cancellingOrder = true;
      cancellingMessageText = 'confirm_canceling_order';
      break;
    case statusCode === ORDER_STATUS.ACCEPTED:
      nextStatusCode = ORDER_STATUS.PROCESSING;
      messageText = 'confirm_change_status';
      cancellingOrder = true;
      cancellingMessageText = 'confirm_canceling_order';
      break;
    case statusCode === ORDER_STATUS.ASSIGNED:
    case statusCode === ORDER_STATUS.PROCESSING:
      nextStatusCode = ORDER_STATUS.WAITING_FOR_PICKUP;
      break;
    case statusCode === ORDER_STATUS.PICKEDUP:
    case statusCode === ORDER_STATUS.OUT_FOR_DELIVERY:
    case statusCode === ORDER_STATUS.WAITING_FOR_PICKUP:
      nextStatusCode = ORDER_STATUS.RETURNED;
      completedButton = true;
      break;
    case statusCode === ORDER_STATUS.RETURNED:
      nextStatusCode = ORDER_STATUS.COMPLETED;
      break;
  }
  return { messageText, cancellingMessageText, nextStatusCode, completedButton, cancellingOrder };
};
const DeliveryKudu = (statusCode: TOrder['order_status_code']) => {
  let nextStatusCode: TOrder['order_status_code'] = ORDER_STATUS.PENDING;
  let messageText: string = 'confirm_change_status_foodics';
  let cancellingOrder: boolean = true;
  let cancellingMessageText: string = 'confirm_canceling_order_foodics';
  let completedButton: boolean = false;

  switch (true) {
    case statusCode === ORDER_STATUS.PENDING:
      nextStatusCode = ORDER_STATUS.ACCEPTED;
      messageText = 'sure_confirm_change_status';
      cancellingOrder = true;
      cancellingMessageText = 'confirm_canceling_delivery_order';
      break;
    case statusCode === ORDER_STATUS.ACCEPTED:
      nextStatusCode = ORDER_STATUS.PROCESSING;
      messageText = 'confirm_change_status';
      cancellingOrder = true;
      cancellingMessageText = 'confirm_canceling_delivery_order';
      break;
    case statusCode === ORDER_STATUS.ASSIGNED:
    case statusCode === ORDER_STATUS.PROCESSING:
      nextStatusCode = ORDER_STATUS.WAITING_FOR_PICKUP;
      break;
    case statusCode === ORDER_STATUS.PICKEDUP:
    case statusCode === ORDER_STATUS.WAITING_FOR_PICKUP:
      nextStatusCode = ORDER_STATUS.OUT_FOR_DELIVERY;
      break;
    case statusCode === ORDER_STATUS.OUT_FOR_DELIVERY:
      nextStatusCode = ORDER_STATUS.RETURNED;
      completedButton = true;
      break;
    case statusCode === ORDER_STATUS.RETURNED:
      nextStatusCode = ORDER_STATUS.COMPLETED;
      break;
  }
  return { messageText, cancellingMessageText, nextStatusCode, completedButton, cancellingOrder };
};

/*
 *
 *
 * without pos
 *
 *
 */
const Pickup = (statusCode: TOrder['order_status_code']) => {
  let nextStatusCode: TOrder['order_status_code'] = ORDER_STATUS.PENDING;
  let messageText: string = 'confirm_change_status';
  const cancellingOrder: boolean = true;
  let cancellingMessageText: string = 'confirm_canceling_order';
  let completedButton: boolean = false;

  switch (true) {
    case statusCode === ORDER_STATUS.PENDING:
      nextStatusCode = ORDER_STATUS.ACCEPTED;
      messageText = 'sure_confirm_change_status';
      break;
    case statusCode === ORDER_STATUS.ACCEPTED:
      nextStatusCode = ORDER_STATUS.PROCESSING;
      break;
    case statusCode === ORDER_STATUS.ASSIGNED:
    case statusCode === ORDER_STATUS.PROCESSING:
      nextStatusCode = ORDER_STATUS.WAITING_FOR_PICKUP;
      break;
    case statusCode === ORDER_STATUS.PICKEDUP:
    case statusCode === ORDER_STATUS.OUT_FOR_DELIVERY:
    case statusCode === ORDER_STATUS.WAITING_FOR_PICKUP:
      nextStatusCode = ORDER_STATUS.RETURNED;
      completedButton = true;
      break;
    case statusCode === ORDER_STATUS.RETURNED:
      nextStatusCode = ORDER_STATUS.COMPLETED;
      break;
    case statusCode === ORDER_STATUS.COMPLETED:
      cancellingMessageText = 'confirm_canceling_order';
      break;
  }
  return { messageText, cancellingMessageText, nextStatusCode, completedButton, cancellingOrder };
};
const Delivery = (statusCode: TOrder['order_status_code']) => {
  let nextStatusCode: TOrder['order_status_code'] = ORDER_STATUS.PENDING;
  let messageText: string = 'confirm_change_status';
  const cancellingOrder: boolean = true;
  let cancellingMessageText: string = 'confirm_canceling_delivery_order';
  let completedButton: boolean = false;

  switch (true) {
    case statusCode === ORDER_STATUS.PENDING:
      nextStatusCode = ORDER_STATUS.ACCEPTED;
      messageText = 'sure_confirm_change_status';
      break;
    case statusCode === ORDER_STATUS.ACCEPTED:
      nextStatusCode = ORDER_STATUS.PROCESSING;
      break;
    case statusCode === ORDER_STATUS.ASSIGNED:
    case statusCode === ORDER_STATUS.PROCESSING:
      nextStatusCode = ORDER_STATUS.WAITING_FOR_PICKUP;
      break;
    case statusCode === ORDER_STATUS.PICKEDUP:
    case statusCode === ORDER_STATUS.WAITING_FOR_PICKUP:
      nextStatusCode = ORDER_STATUS.OUT_FOR_DELIVERY;
      break;
    case statusCode === ORDER_STATUS.OUT_FOR_DELIVERY:
      nextStatusCode = ORDER_STATUS.RETURNED;
      completedButton = true;
      break;
    case statusCode === ORDER_STATUS.RETURNED:
      nextStatusCode = ORDER_STATUS.COMPLETED;
      break;
    case statusCode === ORDER_STATUS.COMPLETED:
      cancellingMessageText = 'confirm_canceling_order';
      break;
  }
  return { messageText, cancellingMessageText, nextStatusCode, completedButton, cancellingOrder };
};

export { orderStatusManager };
